import '../App.css';
import AuthWrapper from '../components_/layout/AuthWrapper';
import SecurityQuestionForm from '../features/forgotPassword/SecurityQuestionForm';
import CreateNewPassword from '../features/forgotPassword/createNewPassword';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { createPasswordValidation } from '../utils/validations';
import { useUpdatePassword, useVerifySecurityQuestionAnswer } from '../apis/auth';
import customToast, { ToastType } from '../components_/Toast';
import { encryptData } from '../utils/encryptJson';
import { useState } from 'react';
import CryptoJS from 'crypto-js';
import { wqkgx } from '../config/keys';
import SuccessModal from '../components/global/SuccessModal';

const CreateNewPasswordPage = () => {
  const queryParams = new URLSearchParams(location.search);
  const email = queryParams?.get('source') ?? '';
  const token = queryParams?.get('token') ?? '';
  const [questionNumber, setQuestionNumber] = useState('');
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const { mutate: verifyAnswer, isPending: verifyAnswerLoading } =
    useVerifySecurityQuestionAnswer();

  const { mutate: updatePassword, isPending: updatePasswordLoading } = useUpdatePassword();
  const answerKey = `answer${questionNumber}`;
  const formik = useFormik({
    initialValues: {
      password: '',
      confirmPassword: '',
      page: 1,
      securityAnswer: '',
      securityQuestion: '',
    },
    validationSchema: createPasswordValidation,
    onSubmit: (values) => {
      if (values?.page === 1) {
        formik.setFieldValue('page', 2);
      } else {
        verifyAnswer(
          encryptData({
            email,
            [answerKey]: CryptoJS.AES.encrypt(formik?.values?.securityAnswer, wqkgx).toString(),
          }),
          {
            onError: (err: Error) => {
              customToast(err?.message ?? 'Could not validate security answer', ToastType.error);
            },
            onSuccess: () => {
              updatePassword(
                encryptData({
                  email,
                  token,
                  newPassword: CryptoJS.AES.encrypt(formik.values.password, wqkgx).toString(),
                }),
                {
                  onError: (err: Error) =>
                    customToast(err?.message ?? 'Could not update password', ToastType.error),
                  onSuccess: () => setShowSuccessModal(true),
                },
              );
            },
          },
        );
      }
    },
  });

  return (
    <AuthWrapper>
      {formik.values.page === 1 ? (
        <CreateNewPassword formik={formik} />
      ) : (
        <SecurityQuestionForm
          formik={formik}
          email={email}
          token={token}
          isLoading={verifyAnswerLoading || updatePasswordLoading}
          setQuestionNumber={setQuestionNumber}
        />
      )}

      <SuccessModal
        showSuccessModal={showSuccessModal}
        setShowSuccessModal={setShowSuccessModal}
        pageComingFrom={'FORGOTPASSWORD'}
        description='Your password has been reset successfully'
        proceedText='Return to login'
        whereTo='/'
      />
    </AuthWrapper>
  );
};

export default CreateNewPasswordPage;
